import { Component, OnInit } from '@angular/core'
import { collection, Firestore, getDocs } from '@angular/fire/firestore'
import { Dog } from 'src/domain/dog'
import { ListDog } from '../components/dog-list/dog-list.component'
import { mapFirebaseDog } from '../service/mapper/dogMapper'

@Component({
    selector: 'app-retired-dogs',
    templateUrl: './retired-dogs.component.html',
    styleUrls: ['./retired-dogs.component.scss'],
    standalone: false
})
export class RetiredDogsComponent implements OnInit {
  retiredDogs: ListDog[] = []

  constructor(private store: Firestore) {}

  ngOnInit(): void {
    getDocs(collection(this.store, 'dogs')).then((snapshot) => {
      this.retiredDogs = snapshot.docs
        .map(
          (doc) =>
            ({
              ...mapFirebaseDog(doc.data() as Dog),
              docId: doc.id,
            } as ListDog)
        )
        .filter((d) => !d.deletedAt && d.retiredAt)
    })
  }
}
